module.exports = __webpack_public_path__ + "img/fabulous1.18a38805.svg";